import ImgPost from "../../../../src/components/imgPost";
import Centralization from "../../../../contents/posts/76-centralization-vs-decentralization/1.png";
import Decentralization from "../../../../contents/posts/76-centralization-vs-decentralization/2.png";
import * as React from 'react';
export default {
  ImgPost,
  Centralization,
  Decentralization,
  React
};